export function actionSetLeadsStatusesFetchIds(value) {
    return {
        type: 'SET_LEADS_STATUSES_FETCH_IDS',
        value: value
    };
}
